import { loadChromeCopy } from "$lib/i18n/copy/chrome";
import { isTranslatedLocale } from "$lib/i18n/locales";
import type { LayoutLoad } from "./$types";

// Every translated page is a file written at build time, like its English
// original: nothing on it depends on who is asking.
export const prerender = true;

// The language of everything under this segment, and the words of the bar,
// footer and switcher around the page in that language. The root layout reads
// both from the page data, which is how the chrome it renders for every page
// comes out in the page's own language.
export const load: LayoutLoad = async ({ params }) => {
  // The parameter matcher admits only a translated language, so this narrows
  // what the router already guarantees.
  if (!isTranslatedLocale(params.lang)) throw new Error(`Not a language: ${params.lang}`);
  return { locale: params.lang, chrome: await loadChromeCopy(params.lang) };
};
